import { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TabDto } from '@asset-metrix/portal-gateway-client-js';

import { getActiveContentGroupTabUrlSearchKey } from '../../../utils/contentTab';

import pageStyles from '../page.module.scss';

export function Tab({
  entity,
  children,
}: {
  entity: TabDto;
  children: ReactNode;
}) {
  const [urlSearchParams] = useSearchParams();
  const isActiveTab =
    urlSearchParams.get(
      getActiveContentGroupTabUrlSearchKey(entity.tabGroup)
    ) === entity.id;

  if (!isActiveTab) {
    return null;
  }

  return (
    <div className={`page-content ${pageStyles['content']}`}>{children}</div>
  );
}
